import { OvlAddScreen } from "../../src/global/globals"
import { ScreenSYSLandinfPage01 } from "./screens/syslandingpage01"

export const SYSLandingPage01_Init = () => {
  OvlAddScreen(ScreenSYSLandinfPage01, "SYSLandingPage01")
}
